 
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Typography from '@mui/material/Typography';
import { api } from '@ifa/trpc-client';
import Link from '@mui/material/Link';

const iconStyles = {
    marginBottom: '0.25rem',
    marginRight: '0.25rem',
    fontSize: '1.15rem',
};

function DashboardTableActionsDownload({ submissionDetailsId }: { submissionDetailsId: number }) {
    const { refetch } = api.submissionDetail.downloadFile.useQuery(
        {
            id: submissionDetailsId,
        },
        {
            enabled: false,
        }
    );

    const addEvent = api.analyticsEvent.create.useMutation();

    const clickHandler = async () => {
        try {
            const { data } = await refetch();
            if (data) {
                const link = document.createElement('a');
                link.setAttribute('data-cy', 'actions-download-link');
                link.href = data;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
            }
            addEvent.mutate({
                eventType: 'FILE_DOWNLOAD',
                submissionDetailsId,
                metadata: {
                    href: data,
                }
            });
        } catch (error) {
            // TODO: handle this properly
            console.error('Error downloading file', error);
        }
    };

    return (
        <Link
            component="button"
            sx={{ cursor: 'pointer' }}
            role="button"
            data-cy="actions-download"
            onClick={clickHandler}
        >
            <FileDownloadIcon color="success" sx={iconStyles} />
            <Typography component="span" sx={{ fontSize: '13px' }}>
                Download file
            </Typography>
        </Link>
    );
}

export default DashboardTableActionsDownload;
